/** @import modules */

import cookies                      from "js-cookie";

import { useParams, useNavigate }   from "react-router-dom";

import { useTranslation }           from "react-i18next";

/** @import models */

import TechInfoModel                from "../../Models/TechnicalModel";

/** @import icons */

import { BsFillCaretDownFill }      from "react-icons/bs";

const NavigationSelect = () => { const 

    { loading, data }   = TechInfoModel     (),

    { t }               = useTranslation    (),

    { id }              = useParams         (),

    navigate            = useNavigate       (),

    Action = id => {

        if ( id === "default" ) return navigate ( `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_techinfo__" ) }` );

        navigate ( `/${ t ( "__permalink_content__" ) }/${ t ( "__permalink_techinfo__" ) }/${ id }` )

    };

    /** @return component */

    return ( <div className="mobile-aside">

        <label className="select shadow-select">

            <select onChange={ e => Action ( e.target.value ) } value={ id || "default" }>

                <option value="default">

                    { loading ? `${ t ( "loading" ) }...` : t ( "select_option" ) }

                </option>

                { ! loading && data.technicalInformation.edges.filter ( 
                    
                    obj => obj.node.language === cookies.get ( 'i18next' ) && obj.node.isPublished === true ).map ( ( techinfo, index ) => 
                    
                <option key={ index } value={ techinfo.node.id }>

                    { techinfo.node.title }

                </option> ) }

            </select>

            <span>
                
                <BsFillCaretDownFill />
                
            </span>

        </label>

    </div> );

}

/** @export NavigationSelect */
 
export default NavigationSelect;